import { S3Client } from '@aws-sdk/client-s3';

// Variables de entorno para Cloudflare R2
const accountId = '988e13930ad95d2dcd829bb7a17bb78e'; // ID para S3 API
const publicId = '168b813ffa0f41548428789ca73fba4e';  // ID para URLs públicas
const accessKeyId = import.meta.env.VITE_R2_ACCESS_KEY_ID;
const secretAccessKey = import.meta.env.VITE_R2_SECRET_ACCESS_KEY;

// URLs base públicas de R2 (siempre usando el dominio .kids)
export const R2_PUBLIC_URLS = {
  MEDIA: 'https://media.financieramente.kids',
  DOCUMENTS: 'https://docs.financieramente.kids'
} as const;

// Configuración del cliente R2
export const r2Client = new S3Client({
  region: 'auto',
  endpoint: `https://${accountId}.r2.cloudflarestorage.com`,
  credentials: {
    accessKeyId: accessKeyId || '',
    secretAccessKey: secretAccessKey || '',
  },
  forcePathStyle: true,
});

// Validar configuración
export const validateR2Config = () => {
  if (!accessKeyId) throw new Error('VITE_R2_ACCESS_KEY_ID no está configurado');
  if (!secretAccessKey) throw new Error('VITE_R2_SECRET_ACCESS_KEY no está configurado');
  return true;
};

// Nombres de los buckets (manteniendo los mismos nombres para consistencia)
export const BUCKET_NAMES = {
  MEDIA: 'financieramente-media',
  DOCUMENTS: 'financieramente-docs'
} as const;

// Configuración de CORS para R2
export const corsConfig = {
  AllowedOrigins: ['*'],
  AllowedMethods: ['GET', 'PUT', 'POST'],
  AllowedHeaders: ['*'],
  MaxAgeSeconds: 3000
};

// Tipos de contenido permitidos con límites de tamaño
export const ALLOWED_CONTENT_TYPES = {
  VIDEO: {
    types: ['video/mp4', 'video/webm'],
    maxSize: 500 * 1024 * 1024, // 500MB
  },
  AUDIO: {
    types: ['audio/mpeg', 'audio/wav', 'audio/ogg'],
    maxSize: 50 * 1024 * 1024, // 50MB
  },
  IMAGE: {
    types: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    maxSize: 5 * 1024 * 1024, // 5MB
  },
  DOCUMENT: {
    types: ['application/pdf'],
    maxSize: 20 * 1024 * 1024, // 20MB
  },
} as const;
